<template>
    <div class="tab-pane fade show active" id="exclusions" role="tabpanel" aria-labelledby="exclusions-tab">
        <div v-bind:class="{ open: uiStates.activeModal == 'exclusionEdit' }" class="slider-modal">
            <transition name="fade">
                <div class="container"  v-if="uiStates.activeModal == 'exclusionEdit'">
                    <a v-on:click="cancelEditExclusion()"  class="close-section">&times;</a>
                    <div class="slider-modal-copy">
                        <div class="row">
                            <div class="col-md-12">
                                <h3>Edit Exclusion</h3>
                            </div>
                        </div>
                        <input-loader :fields="productExclusions.items.groupItems"></input-loader>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <button type="button" class="btn btn-secondary" @click="cancelEditExclusion()">Cancel</button>
                                <button type="button" class="btn btn-primary" @click="updateProductExclusion()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6 clearfix">
                    <h3 class="pt-2 mb-2">Exclusions</h3>
                </div>
                <div class="col-md-6 text-right">
                    <button class="btn btn-primary text-right mb-2" data-toggle="collapse" data-target="#create_exclusion">Create Exclusion</button>
                </div>
            </div>
            <div id="create_exclusion" class="collapse border p-4 mb-1">
                <input-loader :fields="productExclusions.items.groupItems"></input-loader>
                <div class="form-group row">
                    <div class="col-md-12 text-right">
                        <button type="submit" class="btn btn-primary" @click="createProductExclusion()">Create</button>
                        <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#create_exclusion">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4 mt-2">
                <vuetable ref="vuetable"
                    :api-url="grid"
                    :fields="fields"
                    :css="css.table"
                    noDataTemplate="No Exclusions Found"
                    @vuetable:loaded="onLoaded"
                    pagination-path=""
                    :per-page="perPage"
                    :append-params="moreParams"
                    @vuetable:pagination-data="onPaginationData"
                >
                	<template slot="options" slot-scope="props">
                        <div>
                            <div class="dropdown channel-tool-menu text-right ml-1">
                                <button type="button" class="btn btn-outline-primary " data-toggle="dropdown">
                                    <i class="fa fa-cog" aria-hidden="true"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                                    <a  @click="loadEditExclusionForm(props.rowData)" class="dropdown-item">
                                        <span>Edit</span>
                                    </a>
                                    <a class="dropdown-item" @click="deleteProductExclusion(props.rowData.id)">
                                        <span>Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>
                </vuetable>
                <div class="row">
                    <div class="col-md-6">
                        <base-pagination-info
                            :css="css.table"
                            ref="paginationInfo"
                        >
                        </base-pagination-info>
                    </div>
                    <div class="col-md-6">
                        <base-pagination  ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        ></base-pagination>
                    </div>
                </div>
            </div>
            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
    </div>
</template>
<script>
var base_url = window.location.protocol + "//" + window.location.host

import axios from 'axios'
import _ from "lodash";
import moment from 'moment';
import * as Vuetable from 'vuetable-2';
import BasePagination from '../tables/base-pagination.vue';
import BasePaginationInfo from '../tables/base-pagination-info.vue';

import InputLoader from '../form/form-loader.vue';

export default {
    name: 'exclusions',
        components:{
        'input-loader': InputLoader,
        'base-pagination': BasePagination,
        'base-pagination-info': BasePaginationInfo,
    },
    data() {
        return {
            perPage: 10,
            loading: true,
	    	moreParams: {},
            message: "",
            uiStates: {
                errorMessage: true,
                showLoading: true,
                activeModal: '',
            },
            grid: base_url + '/pimapi/products/' + this.$parent.product.info.id + '/exclusions',
            fields: [
                {
                    name: 'reason',
                    title: 'Exclusion Reason'
                },
                {
                    name: 'type',
                    title: 'Type'
                },
                {
                    name: 'start_date',
                    title: 'Start Date',
                    callback: 'formatDate'
                },
                {
                    name: 'end_date',
                    title: 'End Date',
                    callback: 'formatDate'
                },
                {
                   name: '__slot:options'                           ,
                   title: ''
                }
            ],
            css: {
                table: {
                    tableClass: 'table table-middle table-minimal',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    infoClass: '',
                },
            },
            calendarButtonIcon: 'fa fa-calendar',
            inputClass: 'form-control',
            productExclusions: {
                items: {
                    groupingName: 'Exclusions',
                    groupItems: [
                        {
                            "name": "reason",
                            "label": "Exclusion Reason",
                            "required": true,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name": "type",
                            "label": "Type",
                            "required": true,
                            "type": "select",
                            "column": "col-md-6",
                            "value": "",
                            "options": [
                                {
                                    "id": "pre-release",
                                    "name": "Pre Release",
                                    "selected": false
                                },
                                {
                                    "id": "back-order",
                                    "name": "Back Order",
                                    "selected": false
                                },
                                {
                                    "id": "local-only",
                                    "name": "Local Only",
                                    "selected": false
                                }
                            ]
                        },
                        {
                            "name": "start_date",
                            "label": "Start Date",
                            "required": false,
                            "type": "datetime",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name": "end_date",
                            "label": "End Date",
                            "required": false,
                            "type": "datetime",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        }
                    ]
                }
            },
            editExclusionId: null
        }
    },
    methods : {
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        formatDate(value) {
            if(value === null) {
                return 'Never';
            }
            return moment(value).format('MMM Do YYYY');
        },
        onLoaded: function() {
            this.loading = false;
        },
        createProductExclusion() {
            axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/exclusions', {
                'productExclusions' : this.productExclusions
            })
            .then(function(response) {
                this.$refs.vuetable.reload();
                this.collapseForm();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'A new product exclusion has been added'
            }.bind(this))
            .catch(function(error) {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;                
            }.bind(this))
        },
        loadEditExclusionForm(excl) {
            this.collapseForm();
            this.editExclusionId = excl.id;
            this.productExclusions.items.groupItems[0].value = excl.reason;
            this.productExclusions.items.groupItems[1].value = this.convertToKebabCase(excl.type);
            this.productExclusions.items.groupItems[2].value = excl.start_date;
            this.productExclusions.items.groupItems[3].value = excl.end_date;

            this.uiStates.activeModal = 'exclusionEdit';

        },
        cancelEditExclusion() {
            this.editExclusionId = null;
            this.clearFormData();
            this.uiStates.activeModal = '';

        },
        updateProductExclusion() {
            axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/exclusions/' + this.editExclusionId, {
                'productExclusions' : this.productExclusions
            })
            .then(function(response) {
                this.$refs.vuetable.reload();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'The product exclusion (id: ' + this.editExclusionId + ') has been updated';
                this.clearFormData();
                this.uiStates.activeModal = '';
            }.bind(this))
            .catch(function(error) {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this))

        },
        deleteProductExclusion(id){
            axios.delete(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/exclusions/' + id, {

            })
            .then(function(reponse) {
                this.$refs.vuetable.reload();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'The product exclusion (id: ' + id + ') has been removed';
            }.bind(this))
            .catch(function(error) {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this))
        },
        clearFormData() {
            this.productExclusions.items.groupItems.map(x => x.value = "");
        },
        collapseForm: function() {
            $('#create_exclusion').collapse('hide');
        },
        convertToKebabCase(str) {
            if (str == null) {
                return;
            }
            return str.replace(/\s+/g, '-').toLowerCase();
        },
        onChangePage (page) {
            this.$refs.vuetable.changePage(page)
        },
        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.$refs.paginationInfo.setPaginationData(paginationData)
        }
    },
    // watch: {
    //     message: function(query) {
    //         setTimeout(function() {
    //             this.$parent.alert.message = "";
    //         }.bind(this), 3000);
    //     }
    // }

}
</script>

<style lang="scss" scoped>
    .channel-tool-menu{
        display: inline;
        .btn{
            margin-top: -1px;
            width: 26px;
            height: 26px;
            padding: 0 0;
            border-color: #ADADAD;
            color: #686868;
        }
    }
    .messaging{
        color: #566670;
        position: absolute;
        bottom: 2px;
        right: 5px;
        font-size: 9px;

    }
</style>
